const baseProdUrl = "https://api.marginly.com/api";
// const baseStageUrl = "https://api-stage.marginly.com/api";

export const request = <TResponse>(
  url: string,
  config: RequestInit = {},
  baseUrl = baseProdUrl,
): Promise<TResponse> => {
  return fetch(`${baseUrl}/${url}`, config).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw new Error("Something went wrong.");
  });
};
